import { memo } from 'react';
import { hasPerm, P } from '../../../../../utilities/roles/permissions';
import { CellProps } from '../../types';
import { CellEventsHandler } from '../formatters';
import { defaultHeaderRenderer } from '../headers';
import { RightAlign } from '../styles';
import { IColumn } from '../types';

const RightAlignFormatter = memo(function formatter(cellProps: CellProps) {
  return (
    <CellEventsHandler cellProps={cellProps}>
      <RightAlign>{cellProps.row.successPrediction}</RightAlign>
    </CellEventsHandler>
  );
});

export const CONFColumn = (): IColumn => ({
  item: {
    key: 'successPrediction',
    name: 'Confidence',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(88px, .5fr)',
    formatter: RightAlignFormatter,
  },
  visible: ({ role }) => hasPerm(role, P.CONFIDENCE_SCORE_VIEW),
});
